import type { IconData } from '@stacksjs/iconify-core'

export const otherUiHandSelect: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M14 8L8.5 6V1.25a1.25 1.25 0 1 0-2.5 0V9H4.5V7a2 2 0 0 0-2-2H2v5a6 6 0 0 0 12 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default otherUiHandSelect
